import React  from 'react';  

export const patientRecordsConfig = [
    {
        auth: ['user'],
        routes: [
          {
            exact: true,
            path: '/patient-record-list',
            component: React.lazy(() => import('./PatientsList')),
          },
        ],
      },
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/patient-record-list/view',
        component: React.lazy(() => import('./PatientRecordsList')),
      },
    ],
  },
  {
    routes: [
      {
        exact: true,
        path: '/third-party-questionnaire/:questionnaire_id',
        component: React.lazy(() => import('./PatientRecordsList/QuestionnairesThirdParty/QuestionnaireForm')),
      },
    ],
  },
  
 
];